// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preStyle[data-v-4c235608] {\n  height: calc(100vh - 70px);\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
